import React, { Component } from 'react';
import {connect} from 'react-redux';
import 'moment/locale/ru';
import moment from 'moment';
import Tooltip from '../Helpers/Tooltip';
import { observer, inject } from "mobx-react";

class Time extends Component {
  getDate() {
    let date=moment(this.props.value/*,'YYYY-DD-MM HH:mm:ss'*/);
    let offset=0;
    if(this.props.meStore.me.inited && this.props.meStore.me.data.gmt_offset) {
      offset=this.props.meStore.me.data.gmt_offset;
      const unixWithOffset=date.unix()+this.props.meStore.me.data.gmt_offset;
      date=moment.unix(unixWithOffset);
    }

    const curTimeStamp=parseInt(new Date().getTime()/1000)+offset;
    const curDate=moment.unix(curTimeStamp);
    /*
    const date=moment(this.props.value/!*,'YYYY-DD-MM HH:mm:ss'*!/);
    const curDate=moment(new Date());*/
    //temp1.format('DD MMM Y');

    if(!date.isValid()) {
      return '&mdash;';
    }

    if((date.format('DD MMM YYYY')===curDate.format('DD MMM YYYY') || this.props.forcetime) && !this.props.forcedate) {
      //same day
      return (
        <span>
          <Tooltip text={date.format('lll')}>
            {date.format('HH:mm')}
          </Tooltip>
        </span>
      )
    } else {
      if(date.format('YYYY')===curDate.format('YYYY')) {
        return (
          <span>
            <Tooltip text={date.format('lll')}>
              {date.format('D MMMM')}
            </Tooltip>
          </span>
        );
      } else {
        return (
          <span>
            <Tooltip text={date.format('lll')}>
              {date.format('DD.MM.YYYY')}
            </Tooltip>
          </span>
        );
      }
    }



    if(!date.isValid()) {
      return '&mdash;';
    }
    if(this.props.options && this.props.options.use_time) {
      return date.format('HH:mm:ss[<br/>]ll');
    } else {
      return date.format('ll');
    }

  }
  render() {
    return (
      <span>
        {this.getDate()}
      </span>
    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me
  }
}

export default inject("meStore")(observer(Time));